module.exports = function() {
  return new Worker(__webpack_public_path__ + "4f9b222d49c6bd408944.worker.js");
};